var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 35,
    width: 55,
    viewBox: "0 0 400 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M341 271.8H71.4c-16.9 0-30.8-15.9-30.8-32.8V70.1c0-16.9 13.9-30.8 30.8-30.8H341c16.9 0 30.8 13.9 30.8 30.8v168.8c0 16.9-13.8 32.9-30.8 32.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#646667",
    d: "M74.6 268.3c-17.6 0-32-14.3-32-32v-165c0-17.6 14.3-32 32-32h263.3c17.6 0 32 14.3 32 32v165c0 17.6-14.3 32-32 32H74.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 131.343,
    y1: 690.529,
    x2: 131.343,
    y2: 763.676,
    gradientTransform: "matrix(3.06 0 0 -3.06 -195.7 2378.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#fff"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__a)",
    d: "M337.1 265.7H75.4c-16.5 0-29.9-13.5-29.9-29.9v-164c0-16.5 13.5-29.9 29.9-29.9h261.7c16.5 0 29.9 13.5 29.9 29.9v164c0 16.5-13.5 29.9-29.9 29.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 206.211,
    y1: 125.573,
    x2: 206.211,
    y2: 182.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#fff"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__b)",
    d: "m179 181.2 9.3-54.7h14.9l-9.3 54.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 206.211,
    y1: 125.573,
    x2: 206.211,
    y2: 182.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#fff"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__c)",
    d: "M248 127.9c-3-1.1-7.6-2.3-13.4-2.3-14.7 0-25.1 7.4-25.2 18.1-.1 7.9 7.4 12.2 13.1 14.9 5.8 2.7 7.8 4.4 7.7 6.8 0 3.7-4.6 5.3-8.9 5.3-6 0-9.1-.8-14-2.9l-1.9-.9-2.1 12.2c3.5 1.5 9.9 2.9 16.6 2.9 15.7 0 25.8-7.3 26-18.7.1-6.2-3.9-11-12.5-14.9-5.2-2.5-8.4-4.2-8.4-6.8 0-2.3 2.7-4.7 8.5-4.7 4.9-.1 8.4 1 11.2 2.1l1.3.6 2-11.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 206.211,
    y1: 125.573,
    x2: 206.211,
    y2: 182.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#fff"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__d)",
    d: "M286.2 126.6h-11.5c-3.6 0-6.2 1-7.8 4.5l-22.1 50.1h15.7s2.6-6.7 3.1-8.2h19.1c.4 1.9 1.8 8.2 1.8 8.2h13.8l-12.1-54.6m-18.4 35.2c1.2-3.2 5.9-15.3 5.9-15.3-.1.1 1.2-3.2 2-5.2l1 4.7s2.9 13.1 3.5 15.8h-12.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 206.211,
    y1: 125.573,
    x2: 206.211,
    y2: 182.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#fff"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__e)",
    d: "m166.5 126.6-14.6 37.3-1.6-7.6c-2.7-8.7-11.2-18.2-20.6-22.9l13.3 47.8h15.8l23.5-54.6h-15.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 206.211,
    y1: 125.573,
    x2: 206.211,
    y2: 182.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    style: {
      stopColor: "#f1f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    style: {
      stopColor: "#fff"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__f)",
    d: "M138.4 126.5h-24l-.2 1.1c18.7 4.5 31.1 15.5 36.2 28.6l-5.2-25.1c-1-3.4-3.6-4.4-6.8-4.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0059A0",
    d: "m179 181.2 9.3-54.7h14.9l-9.3 54.7zM248 127.9c-3-1.1-7.6-2.3-13.4-2.3-14.7 0-25.1 7.4-25.2 18.1-.1 7.9 7.4 12.2 13.1 14.9 5.8 2.7 7.8 4.4 7.7 6.8 0 3.7-4.6 5.3-8.9 5.3-6 0-9.1-.8-14-2.9l-1.9-.9-2.1 12.2c3.5 1.5 9.9 2.9 16.6 2.9 15.7 0 25.8-7.3 26-18.7.1-6.2-3.9-11-12.5-14.9-5.2-2.5-8.4-4.2-8.4-6.8 0-2.3 2.7-4.7 8.5-4.7 4.9-.1 8.4 1 11.2 2.1l1.3.6 2-11.7M286.2 126.6h-11.5c-3.6 0-6.2 1-7.8 4.5l-22.1 50.1h15.7s2.6-6.7 3.1-8.2h19.1c.4 1.9 1.8 8.2 1.8 8.2h13.8l-12.1-54.6m-18.4 35.2c1.2-3.2 5.9-15.3 5.9-15.3-.1.1 1.2-3.2 2-5.2l1 4.7s2.9 13.1 3.5 15.8h-12.4zM166.5 126.6l-14.6 37.3-1.6-7.6c-2.7-8.7-11.2-18.2-20.6-22.9l13.3 47.8h15.8l23.5-54.6h-15.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A61C",
    d: "M138.4 126.5h-24l-.2 1.1c18.7 4.5 31.1 15.5 36.2 28.6l-5.2-25.1c-1-3.4-3.6-4.4-6.8-4.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Visa_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 131.343,
    y1: 763.756,
    x2: 131.343,
    y2: 741.511,
    gradientTransform: "matrix(3.06 0 0 -3.06 -195.7 2378.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#273a8a"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Visa_svg__g)",
    d: "M367 109.7V70.6c0-16.7-13.4-29-30.8-29H76.4c-17.7 0-30.9 12.3-30.9 29v39.1H367z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A61C",
    d: "M45.5 198.7v38.6c0 16.5 13.4 28.7 30.7 28.7H336c17.7 0 30.9-12.1 30.9-28.7v-38.6H45.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#488ECC",
    d: "M337.1 41.6H75.3c-16.9 0-29.9 12.2-29.9 29.9V79c0-16.5 7-33.9 29.9-33.9H337c21 0 29.9 17.4 29.9 33.9v-7.5c.1-16.5-13.1-29.9-29.8-29.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE7429",
    d: "M75.3 266H337c16.9 0 29.9-12.2 29.9-29.9v-7.5c0 16.5-7 33.9-29.9 33.9H75.3c-21 0-29.9-17.4-29.9-33.9v7.5c0 16.5 13.2 29.9 29.9 29.9z"
  })));
};
export default SvgVisa;